import gql from 'graphql-tag';
import { ProductAttributeOptionAllData } from '../fragments';

export default gql`
mutation createProductAttributeOption (
    $label: String!
    $is_active: Boolean!
    $is_default: Boolean
    $product_attribute_id: ID!
    $after: ID
) {
    createProductAttributeOption (input: {
        label: $label
        is_active: $is_active
        is_default: $is_default
        product_attribute_id: $product_attribute_id
        after: $after
    }) {
        ...ProductAttributeOptionAllData
    }
}
${ProductAttributeOptionAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/createProductAttributeOption.ts